<nz-select
  nzShowSearch
  nzServerSearch
  [ngModel]="ownerId"
  [nzAllowClear]="true"
  [nzPlaceHolder]="'ADD_CAR_INSPECTION.AGENT' | translate"
  [nzLoading]="loading$ | async"
  [nzDisabled]="disabled"
  (nzFocus)="selectTouch()"
  (nzOnSearch)="ownerName$.next($event)"
  (ngModelChange)="selectChange($event)"
>
  <ng-container *ngIf="(searching$ | async) === false">
    <nz-option
      *ngFor="let owner of owners$ | async"
      [nzLabel]="getLabel(owner)"
      [nzValue]="owner.id"
    ></nz-option>
  </ng-container>
  <nz-option *ngIf="searching$ | async" nzDisabled nzCustomContent>
    <span nz-icon nzType="loading" nzTheme="outline"></span>
    {{ 'ADD_CAR_INSPECTION.SEARCHING' | translate }}
  </nz-option>
</nz-select>
